
function lerp(a, b, r){
    return Math.min(a + ((b -a) * r), b);
}
function clamp(v, min=0, max=1){
    return Math.max(min, Math.min(v, max));
}

function log(...params){
    console.log(...params);
}

function deg2Rad(degrees){
    return degrees * Math.PI / 180;
}

function rad2Deg(rad){
     return (rad * 180.0) / Math.PI;
}

function checkHash(tag){
    return tag && window.location.hash?.includes(tag);
}

function isMobile(){
  
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    /*
    const filter = "win16|win32|win64|mac|macintel";

    if(navigator.platform){

        if(filter.indexOf(navigator.platform.toLowerCase()) < 0) {
            return true;
        } else {
            return false;
        }
    }
    */
}

export {lerp, clamp, log, deg2Rad, rad2Deg, checkHash, isMobile};